<template>
	<div>
		<div class="wrapper1200" style="margin-top: 20px;display: flex;margin-bottom: 88px;">
			<div class="allCategories">
				<div class="category">所有类目</div>
				<div class="consultingService" v-for="(item,index ) in inhBalance" :key="index">
					<div class="ngService flex row-between" @click="showHide(item,index)">
						<div>{{item.name}}</div>
						<img src="../assets/icon/upArrow.png" alt="" v-if="current==index" />
						<img src="../assets/icon/downArrow.png" alt="" v-else />
					</div>
					<ul class="allControl flex" v-show="current == index">
						<li class="serli" v-for="(items,indexs) in econdaryClassi" :key="indexs"
							@click.stop="clitchBalance(items,indexs)" :class="{'acitre':oSwitchBalan==indexs}">
							{{items.name}}
						</li>
					</ul>
				</div>
			</div>
			<div class="olContent">
				<div class="individualContent" v-for="(item,index) in contentList" :key="index"
					@click="clickOnDetails(item)">
					<img :src="item.mainImg" alt="" />
					<div class="articleContent">
						<div class="title">{{item.title}}</div>
						<div class="contentse">
							{{item.content}}
						</div>
						<div class="times">{{item.createTime}}</div>
					</div>
				</div>
				<div class="defaults" v-if="contentList==''">
					<el-empty description="暂无数据"></el-empty>
				</div>
				<div style="text-align: center;">
					<el-pagination layout="prev, pager, next" :total="total" @current-change='pagings'>
					</el-pagination>
				</div>

			</div>

			<!-- <div v-if="detailsDisplay==''" class="details">
				<div class="bread">
					<div>中医知识库</div>
					<div>></div>
					<div>{{inhBalance[current].name}}</div>
					<div>></div>
					<div>{{econdaryClassi[oSwitchBalan].name}}</div>
				</div>
				<div>
					
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import {
		listClassify,
		knowledgeBase,
		knowledgeBaseDetails
	} from "@/api/api.js"
	export default {
		data() {
			return {
				current: 0,
				oSwitchBalan: 0,
				inhBalance: [],
				econdaryClassi: [{
					name: '全部'
				}],
				contentList: '',
				detailsDisplay: '',
				total: 0,
				pages: 1
			}
		},
		created() {
			this.classification()
		},
		mounted() {
			console.log(this.$route.query.current)
			if (this.$route.query.current != undefined) {
				this.current = this.$route.query.current
				this.oSwitchBalan = this.$route.query.oSwitchBalan
			}
		},
		methods: {
			pagings(e) {
				this.pages = e
				console.log(e)
				this.getGoods()
			},

			clickOnDetails(item) {
				this.$router.push({
					path: '/knowledgeDetails',
					query: {
						id: item.repositoryId
					}
				})
				// knowledgeBaseDetails({
				// 	repositoryId: item.repositoryId
				// }).then(res => {
				// 	this.detailsDisplay = res.data
				// 	console.log(res, '2222222');
				// })
			},
			//一级分类
			async classification() {
				await listClassify().then(res => {
					this.inhBalance = res.data
					this.secondaryClassification()
					console.log(res, '2222222');
				})
			},
			//二级分类
			async secondaryClassification() {
				await listClassify({
					superior: this.inhBalance[this.current].classifyId
				}).then(res => {
					this.econdaryClassi.push(...res.data)
					this.getGoods()
					console.log(res, '2222222');
				})
			},
			showHide(item, index) {
				console.log(index)
				this.current = index
				this.pages = 1
				this.econdaryClassi = [{
					name: '全部'
				}]
				this.oSwitchBalan = 0
				this.secondaryClassification()
			},
			clitchBalance(item, index) {
				console.log('123123123')
				// if (index != 0) {
				// 	// this.ider = item.id
				// } else {
				// 	// this.ider = ''
				// }
				this.pages = 1
				this.oSwitchBalan = index
				this.getGoods();
			},
			async getGoods() {
				await knowledgeBase({
					primaryClassifyId: this.inhBalance[this.current].classifyId,
					secondaryClassifyId: this.econdaryClassi[this.oSwitchBalan].classifyId,
					pageNum: this.pages
				}).then(res => {
					this.contentList = res.rows
					this.total = res.total
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	ul {
		list-style-type: none;
	}

	.defaults {
		text-align: center;
		margin: 0 auto;
		width: 100%;
	}

	.allCategories {
		// width: 220px;
		// flex: 1;
		cursor: default;

		.category {
			width: 202px;
			background: #D89A3A;
			font-size: 16px;
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			color: #FFFFFF;
			line-height: 54px;
			padding-left: 18px;
		}

		.consultingService {
			width: 220px;

			.ngService {
				width: 200px;
				background: #F1F1F1;
				padding: 18px 10px;
				font-size: 15px;
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				color: #333333;

				img {
					width: 22px;
					height: 22px;
				}
			}

			.allControl {
				flex-flow: row wrap;
				padding: 0 10px;
				text-align: center;

				.acitre {
					background: #D89A3A;
					color: #FFFFFF !important;
				}

				.serli {
					height: 30px;
					width: 50%;
					line-height: 30px;
					font-size: 13px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #666666;
				}
			}
		}
	}

	.olContent {
		margin-left: 20px;
		flex: 1;

		.individualContent {
			background: #FFFFFF;
			padding: 16px 18px;
			display: flex;
			align-items: center;
			margin-bottom: 10px;

			img {
				width: 90px;
				height: 90px;
				border-radius: 6px;
			}

			.articleContent {
				margin-left: 16px;

				.title {
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 15px;
					color: #666666;
					font-weight: bold;
				}

				.contentse {
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 12px;
					color: #666666;
					margin: 8px auto;
				}

				.times {
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 10px;
					color: #AAAAAA;
				}
			}
		}
	}

	.details {
		margin-left: 20px;
		flex: 1;
		cursor: default;

		.bread {
			display: flex;
			align-items: center;

			div {
				margin-right: 10px;
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 14px;
				color: #666666;
			}
		}
	}
</style>